<footer class="footer d-lg-block d-none">
  <div class="container-fluid footer-body d-flex justify-content-center">
    <div class="grid-box d-grid justify-content-center">
      <div class="items">
        <p class="title-24">
          <img src="/icons/rebelanLogo.png"
               style="width: 40px;height: 40px">
          {{ Config.domain.Title }}
        </p>
        <span>
          {{ Config.branch.Details.ContactUs }}
        </span>
      </div>
      <div class="items">
        <p class="title-24 me-2">{{ 'ContactUs' | translate }}</p>
        <div class="d-flex align-items-center mb-4">
          <img class="ms-2"
               src="/icons/location.svg">
          <span>
          {{ Config.branch.Details.Address }}
        </span>
        </div>
        <span>
            <img class="ms-2"
                 src="/icons/call-calling.svg">
          {{ Config.branch.Details.Phone }}
          </span>
      </div>
      <div class="items d-flex flex-column align-items-center">
        <p class="title-24">{{ 'ConnectionWithUs' | translate }}</p>
        <div class="d-flex justify-content-center"
             style="gap: 31px">
          @for (social of Config.branch.Details.SocialMedias; track $index) {
            @if (social.Type === "TELEGRAM") {
              <img (click)="onSocialMedialClicked(social)"
                   src="/icons/whatsapp.svg">
            } @else if (social.Type === "INSTAGRAM") {
              <img (click)="onSocialMedialClicked(social)"
                   src="/icons/instagram.svg">
            } @else {
            }
          }
        </div>
      </div>
      <div class="items certificates-section">
        <p class="title-24">{{ 'Certificates' | translate }}</p>
        <div class="certificates-container">
          @for (certificate of Config.branch.Details.Certificates; track $index) {
            <div
              class="certificate-item cursor-pointer p-4 d-flex align-items-center justify-content-center border-complete-200 rounded mr-2">
              <div class="social">
                <div [innerHTML]="domSanitizer.bypassSecurityTrustHtml(certificate.URI)"></div>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="items">
        <div class="map-box">
          <app-frontend-map [(latitudePointer)]="Config.branch.Details.AddressLatitude"
                            [(longitudePointer)]="Config.branch.Details.AddressLongitude"
                            [addressTitle]="Config.branch?.Details?.Address"
                            [height]="'100%'"
                            [isClickable]="true"
                            [openMapOnClick]="true"
                            [width]="'100%'"></app-frontend-map>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-bar d-flex align-items-center justify-content-between">
    <span>COMETA GROUP</span>
    <span>2024 ARR, All right reserved</span>
  </div>
</footer>
<nav class="navbar d-lg-none d-block">
  <ul>
    <li (click)="onHomeClicked()"
        [routerLinkActive]="'activeItem'"
        class="d-flex flex-column align-items-center"
        routerLink="menu">
      <div class="position-relative circle-box">
        <img class="img-top"
             src="/icons/Ellipse.svg">
      </div>
      <a>
        <img src="/icons/home-footer.svg">
        <span>{{ 'Home' | translate }}</span>
      </a>
    </li>
    <li (click)="onPackagesClicked()"
        [routerLinkActive]="'activeItem'"
        class="d-flex flex-column align-items-center"
        routerLink="landing">
      <div class="position-relative circle-box">
        <img class="img-top"
             src="/icons/Ellipse.svg">
      </div>
      <a>
        <img src="/icons/info-circle-gray.svg"
             width="24">
        <span>{{ 'Information' | translate }}</span>
      </a>
    </li>
    <li (click)="onBasketClicked()"
        [routerLinkActive]="'activeItem'"
        class="d-flex flex-column"
        routerLink="basket">
      <div class="position-relative circle-box">
        <img class="img-top"
             src="/icons/Ellipse.svg">
      </div>
      <a>
        <img src="/icons/shopping-cart-solid.svg">
        <span style="font-weight: 300 !important;">{{ 'Cart' | translate }}</span>
      </a>
    </li>
    @if (authenticationService.hasAccount()) {
      <li (click)="onOrdersClicked()"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLinkActive]="'activeItem'"
          [routerLink]="Config.branch?.UniqueIdentifier ? ['/', RouteUtil.ORDERS_COMPONENT, Config.branch.UniqueIdentifier] : ['/']"
          class="d-flex flex-column">
        <div class="position-relative circle-box">
          <img class="img-top"
               src="/icons/Ellipse.svg">
        </div>
        <a>
          <svg fill=""
               height="24"
               viewBox="0 0 24 24"
               width="24"
               xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.73 19.7C7.55 18.82 8.8 18.89 9.52 19.85L10.53 21.2C11.34 22.27 12.65 22.27 13.46 21.2L14.47 19.85C15.19 18.89 16.44 18.82 17.26 19.7C19.04 21.6 20.49 20.97 20.49 18.31V7.04C20.5 3.01 19.56 2 15.78 2H8.22C4.44 2 3.5 3.01 3.5 7.04V18.3C3.5 20.97 4.96 21.59 6.73 19.7Z"
              fill="#ADA298"/>
            <path d="M8 7H16"
                  stroke="#FFFFFF"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"/>
            <path d="M9 11H15"
                  stroke="#FFFFFF"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"/>
          </svg>
          <span style="font-weight: 300 !important;">{{ 'Orders' | translate }}</span>
        </a>
      </li>
      <li (click)="onProfileClicked()"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLinkActive]="'activeItem'"
          class="d-flex flex-column"
          routerLink="/account">
        <div class="position-relative circle-box">
          <img class="img-top"
               src="/icons/Ellipse.svg">
        </div>
        <a>
          <img src="/icons/user-foot.svg">
          <span>{{ 'Profile' | translate }}</span>
        </a>
      </li>
    } @else {
      <li (click)="onLoginClicked()"
          [routerLinkActive]="'activeItem'"
          class="d-flex flex-column"
          routerLink="Login">
        <div class="position-relative circle-box">
          <img class="img-top"
               src="/icons/login.svg">
        </div>
        <a>
          <img src="/icons/user.svg">
          <span>{{ 'LogIn' | translate }}</span>
        </a>
      </li>
    }
  </ul>
</nav>

